import React from "react";
import { Message } from "@/models/conversation";

interface UserMessageProps {
  message: Message;
}

export const UserMessage: React.FC<UserMessageProps> = ({ message }) => {
  return (
    <div className="flex justify-end">
      <div className="max-w-md">
        <div className="bg-[#E1EAFF] px-3 py-2 rounded-md inline-block ml-auto">
          <div className="text-[#333333] leading-relaxed break-all whitespace-pre-wrap">{message.content}</div>
        </div>
      </div>
    </div>
  );
};
